export default __webpack_public_path__ + "src/images/reports/marker/default/verification@3x.png";